const _ = require('lodash')
const moment = require('moment')
const { setDataList } = require('../../../../apps/KpModule/actions')

export const module_ = {
    object: 'Batch',
    name: 'Payment',
    tKey: 'mTitle_batchPayment',
    objectIdentifier: 'reference',
    newable: false,
    removable: false,
    category: {
        path: 'menuTitle_bank',
        icon: 'bank'
    },
    viewMap: {
        dt: [
            'reference',
            {path: 'amount', tKey: 'amount(€)', tooltip: true},
            {path: 'requestsReferences', initiallyNotVisible: true},
            {path: 'orderLinesLength', tKey: 'number'},
            {path: 'status', translate: true},
            {path: 'creationDate', tKey: 'dateAndTime'},
            {path: 'paymentDate', tKey: 'payment'},
            {path: 'xlsxFile', tKey: 'xlsx', width: 50},
            {path: 'xmlFile', tKey: 'xml', width: 50}
        ],
        form: {
            fields: [
                {path: 'reference', disabled: true},
                {
                    path: 'orderLines',
                    fieldPath: ['id', 'fullReference', 'amount', 'processType'],
                    display: 'fullReference',
                    filters: ['selectedOnly'],
                    subscriptions: {
                        onChange: (newValue, oldValue, { formInitialize, module, store }) => {
                            const amount = module.viewMap.form.fields.find(
                                field => field.path === 'amount'
                            )
                            const number = module.viewMap.form.fields.find(
                                field => field.path === 'orderLinesLength'
                            )

                            if (newValue) {
                                const total = newValue.reduce((acc, line) => acc + parseFloat(line.amount), 0)
                                amount.setValue(_.round(total, 2))
                                number.setValue(newValue.length)
                            }else{
                                amount.setValue(0)
                                number.setValue(0)
                            }
                        }
                    }
                },
                {path: 'amount', tKey: 'amount(€)', disabled: true},
                {path: 'orderLinesLength', tKey: 'number', disabled: true},
                {path: 'paymentDate', type: 'datePicker', required: true},
                {path: "buttons", hidden: true}
            ],
            onOpen: ({module, state, store}) => {
                const paymentDate = module.viewMap.form.fields.find(
                    field => field.path === 'paymentDate'
                )
                const paymentDateValue = paymentDate.getValue()

                paymentDate.setValue(
                    paymentDateValue
                        ? moment(paymentDateValue).format('YYYY-MM-DD')
                        : moment().format('YYYY-MM-DD')
                )

                const orderLines = state.edit.object.data.orderLines
                if(orderLines) {
                    store.dispatch(
                        setDataList(
                            "m-C-payment.Batch_orderLines",
                            orderLines
                        )
                    )
                }
            }
        }
    },
    filters: [
        'byExercise',
        {
            path: "controlStep",
            match: function(request) {
                return ['controlled', 'paid'].includes(request.status)
            }
        },
        {
            title: "Status",
            path: "status",
            tKey: "status",
            type: 'tags',
            default: [
                {id: 'controlled'}
            ],
            object: "PaymentStatus",
            display: "name",
            client: true,
            query: function (context) {
                const statusArray = _.get(context, "data.status")

                return statusArray
                    ? {status: {$in: statusArray.map(o => o.id)}}
                    : {status: false}
            }
        },
    ]
}
